import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { BtnChiTietNhanVien } from "./ChiTietNhanVien/BtnChiTietNhanVien";
import { BtnChiTietSoDuNo } from "./ChiTietSoDuNo/BtnChiTietSoDuNo";

export const ContentTable = ({ listDuNoGiaoNhanVien, dataSearch }) => {
  const pageStartIndex = (dataSearch.pageIndex - 1) * dataSearch.pageSize;
  return listDuNoGiaoNhanVien.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-14 flex-basis-16-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center"> {pageStartIndex + index + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-30 flex-basis-20-6-sm">
        <span className="mobile-column-name">Nhân viên</span>
        <div className="center-wrapper">
          <BtnChiTietNhanVien item={item} />
          <br />
          {item.Phone != "" && (
            <div className="text-left">
              {"(ĐT: "}
              {item.Phone}
              {" - TK: "}
              {item.UserName}
              {")"}
            </div>
          )}
        </div>
      </div>

      <div className="custom-table-cell flex-basis-30 flex-basis-30-4-sm">
        <span className="mobile-column-name">Số dư nợ</span>
        <div className="center-wrapper">
          <p className="text-right">
            <BtnChiTietSoDuNo item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm action-cell">
        <span className="mobile-column-name">Số hợp đồng</span>
        <div className="center-wrapper">
          <p className="text-center">{item.SoHopDong}</p>
        </div>
      </div>
    </div>
  ));
};
